import { format } from "date-fns";

const MS_MULTIPLIER = 1000;

export const unixTimestampToMDY = (date: number) => {
  const dateInMilliseconds = date * MS_MULTIPLIER;

  return format(dateInMilliseconds, "MMMM do, yyyy");
};
